'use client';

import React, { useState } from 'react';
import Link from 'next/link';

const templates = [
  {
    id: 'tpl-creator',
    name: 'Creator',
    bg: 'template-creator',
    headerBg: 'bg-gradient-brand',
    textColor: 'text-foreground',
    btnBg: 'bg-primary/10 border-primary/20 text-primary',
    free: true,
  },
  {
    id: 'tpl-minimal',
    name: 'Minimal',
    bg: 'template-minimal',
    headerBg: 'bg-muted',
    textColor: 'text-foreground',
    btnBg: 'bg-foreground text-background',
    free: true,
  },
  {
    id: 'tpl-influencer',
    name: 'Influencer',
    bg: 'template-influencer',
    headerBg: 'bg-gradient-to-r from-pink-400 to-rose-500',
    textColor: 'text-foreground',
    btnBg: 'bg-pink-500 text-white border-0',
    free: true,
  },
  {
    id: 'tpl-business',
    name: 'Business',
    bg: 'template-business',
    headerBg: 'bg-gradient-to-r from-emerald-500 to-teal-600',
    textColor: 'text-foreground',
    btnBg: 'bg-emerald-600 text-white border-0',
    free: false,
  },
  {
    id: 'tpl-dark',
    name: 'Dark',
    bg: 'template-dark',
    headerBg: 'bg-gradient-to-r from-violet-900 to-purple-900',
    textColor: 'text-white',
    btnBg: 'bg-white/10 border-white/20 text-white',
    free: false,
  },
];

export default function LandingTemplates() {
  const [active, setActive] = useState('tpl-creator');

  return (
    <section id="templates" className="py-20">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-700 text-primary uppercase tracking-widest mb-3">Templates</span>
          <h2 className="text-4xl font-800 text-foreground mb-4">
            Pick a style that's yours
          </h2>
          <p className="text-lg text-muted-foreground max-w-xl mx-auto">
            Start with a template, then make it your own with custom colors and fonts.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {templates?.map((tpl) => (
            <button
              key={tpl?.id}
              onClick={() => setActive(tpl?.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-600 border transition-all duration-200 ${
                active === tpl?.id
                  ? 'bg-primary text-white border-primary' :'bg-card border-border text-muted-foreground hover:border-primary/40 hover:text-foreground'
              }`}
            >
              {tpl?.name}
              {!tpl?.free && (
                <span className="text-xs px-1.5 py-0.5 rounded-full bg-accent/20 text-accent font-700">Pro</span>
              )}
            </button>
          ))}
        </div>

        {/* Template preview */}
        {templates?.map((tpl) => (
          <div
            key={tpl?.id}
            className={`${active === tpl?.id ? 'block' : 'hidden'} flex justify-center`}
          >
            <div className={`w-72 rounded-3xl overflow-hidden border border-border card-shadow-lg ${tpl?.bg}`}>
              {/* Header */}
              <div className={`${tpl?.headerBg} p-6 flex flex-col items-center`}>
                <div className="w-16 h-16 rounded-full bg-white/30 border-2 border-white/50 flex items-center justify-center font-800 text-xl text-white mb-3">
                  P
                </div>
                <p className={`font-700 text-lg ${tpl?.name === 'Dark' ? 'text-white' : 'text-white'}`}>Priya Sharma</p>
                <p className={`text-xs mt-1 ${tpl?.name === 'Dark' ? 'text-white/70' : 'text-white/80'}`}>Content Creator · Mumbai</p>
              </div>

              {/* Links */}
              <div className="p-4 space-y-2.5">
                {['Latest YouTube Video', 'Instagram Feed', 'Shop My Merch']?.map((label, i) => (
                  <div
                    key={`${tpl?.id}-link-${i}`}
                    className={`flex items-center justify-center py-2.5 px-4 rounded-xl border text-sm font-600 cursor-pointer ${tpl?.btnBg}`}
                  >
                    {label}
                  </div>
                ))}
                <p className={`text-center text-xs mt-3 ${tpl?.name === 'Dark' ? 'text-white/40' : 'text-muted-foreground'}`}>
                  biolink.app/priya.creates
                </p>
              </div>
            </div>
          </div>
        ))}

        <div className="text-center mt-10">
          <Link
            href="/template-selection"
            className="btn-primary inline-flex items-center gap-2 font-600 px-8 py-3.5 rounded-xl"
          >
            Browse All Templates
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}